var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage scrolled-secrets"
  }, [_c('div', {
    staticClass: "left-side"
  }, [_c('div', {
    staticClass: "instructions-scrolled-secrets"
  }, [_vm._v("\n      Scroll down to read the passage. Move each label to the correct place. Then type the word.\n    ")]), _c('div', {
    staticClass: "scrollable-container"
  }, [_c('h3', {
    staticClass: "round-title"
  }, [_vm._v("\n        " + _vm._s(_vm.currentRound.roundTitle) + "\n      ")]), _c('img', {
    attrs: {
      "src": _vm.currentRound.image,
      "alt": ""
    }
  }), _vm._l(_vm.currentRound.paragraphs, function (paragraph, idx) {
    return _c('div', {
      key: idx,
      staticClass: "description"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })]);
  })], 2)]), _c('div', {
    staticClass: "right-side"
  }, [_c('div', {
    staticClass: "sentences-list"
  }, _vm._l(_vm.currentRound.options, function (option, idx) {
    return _c('div', {
      key: idx,
      staticClass: "sentence-ct"
    }, [!_vm.options[idx].replaced ? _c('div', {
      staticClass: "sentence-item droppables",
      attrs: {
        "id": ("droppable-" + (option.id))
      }
    }, [_c('svg', {
      staticClass: "border-style",
      attrs: {
        "height": "50",
        "width": "160"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.cardBorder)
      }
    }), _c('p', {
      staticClass: "type-line"
    }, [_vm._v(_vm._s(option.text))])]) : _vm._e()]);
  }), 0), _vm.currentRound.options ? _c('div', {
    staticClass: "results-container"
  }, _vm._l(_vm.currentRound.options, function (option, idx) {
    return _c('div', {
      key: idx,
      staticClass: "results-row column-row"
    }, [_c('div', {
      staticClass: "sentence-definition"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(option.label)
      }
    })]), _c('div', {
      staticClass: "sentence-definition"
    }), _c('div', {
      staticClass: "sentence-placeholder target-slot"
    }, [!_vm.options[idx].replaced ? _c('svg', {
      staticClass: "border-style",
      attrs: {
        "height": "50",
        "width": "160",
        "id": ("droparea-" + idx)
      },
      domProps: {
        "innerHTML": _vm._s(_vm.cardBorderGrey)
      }
    }) : _vm._e(), _vm.options[idx].replaced ? _c('svg', {
      staticClass: "border-style dd",
      attrs: {
        "height": "50",
        "width": "160"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.cardBorder)
      }
    }) : _vm._e(), _vm.options[idx].replaced ? _c('blinking-cursor-text', {
      attrs: {
        "class-name": 'type-line',
        "text": _vm.options[idx].text,
        "text-step": _vm.options[idx].stepNumber,
        "round-id": _vm.currentRound.roundIndex
      }
    }) : _vm._e()], 1)]);
  }), 0) : _vm._e()]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }